import { useEffect, useState } from "react";
import ProjectCard from "../../../../components/ProjectCard/ProjectCard";
import style from './EmployeeProjects.module.css';
import { useNavigate, useParams } from "react-router-dom";
import EmployeeNavBar from "../../Navbar/EmployeeNavbar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";
import ProjectCardLoader from "../../../../components/LoadingComponents/ProjectCardLoader/ProjectCardLoader";

export default function EmployeeProjects() {
    const [projects, setProjects] = useState([]);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true)

    const { employeeId } = useParams();
    const navigate = useNavigate();
    const projectsPerPage = 6;
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    // Fetch projects API
    useEffect(() => {
        fetch(`${apiurl}/employee/${employeeId}/my-projects`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then((res) => res.json())
            .then((d) => {
                setLoading(false)
                setProjects(d.projects);
                console.log(setMessage)
            })
            .catch((error) => {
                setError(error.message)
                setLoading(true)
            });
    }, [apiurl, employeeId, token]);

    // Pagination
    const indexOfLastProject = currentPage * projectsPerPage;
    const indexOfFirstProject = indexOfLastProject - projectsPerPage;
    const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);

    const totalPages = Math.ceil(projects.length / projectsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    return (
        <>
            <div className="container">
                <EmployeeNavBar />
                <div className={style.projectPage}>
                    {error && <p className="text-danger">{error}</p>}

                    <div className="row mt-1 ">
                        <div className="col-lg-6 ps-4 ps-lg-3">
                            <BreadCrumb
                                link={`/employee-dashboard/${employeeId}`}
                                name="Dashboard"
                                icon={true}
                            />
                            <BreadCrumb
                                link={`/employee-dashboard/${employeeId}/all-projects`}
                                name="All Projects"
                                icon={false}
                            />
                        </div>
                        <div className="col-lg-4"></div>
                        <div className="col-lg-2 text-end pe-5 d-none d-lg-block">
                            <p> Projects : <b>{projects.length}</b></p>
                        </div>
                    </div>

                    <div className="row ">
                        {message && <p className="text-danger text-center" style={{ letterSpacing: '1px', }}>{message}</p>}
                    </div>
                    <div className="row">
                        {loading ?
                            <>
                                {Array.from({ length: 6 }).map((_, idx) => {
                                    return (
                                        <>
                                            <div className="col-12 col-lg-4" key={idx}>
                                                <ProjectCardLoader />
                                            </div>
                                        </>
                                    )
                                })}
                            </>
                            :
                            <>
                                {currentProjects.map((data) => (
                                    <div className="col-12  col-lg-4" key={data._id}>
                                        <ProjectCard
                                            title={data.title}
                                            platform={data.platform}
                                            team={data.team}
                                            description={data.description}
                                            percentage={data.percentage}
                                            link={`/employee-dashboard/${employeeId}/projects/${data._id}`}
                                        />
                                    </div>
                                ))}
                            </>
                        }


                    </div>
                </div>
            </div >

            {/* Fixed Pagination Bar */}
            <div div className="row mb-5 mt-5" >
                <div className="col-12 text-center">
                    <button
                        style={{ border: 'none' }}
                        className="btn mx-2"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                    >
                        <b>{"<<"}</b>
                    </button>
                    <span className="mx-2">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        style={{ border: 'none' }}
                        className="btn mx-2"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        <b>{">>"}</b>
                    </button>
                </div>
            </div >
        </>
    );
}
